import { useIntl } from 'react-intl';
import { WooRequestFieldsFragment } from 'api/graphql-types';
import { BaseModule } from 'modules/base-module/base-module';

import styles from './open-body.module.scss';

const OpenBody = ({
	description,
	publishedAt,
	startDate,
	endDate,
	category,
	caseNumber,
	keywords
}: WooRequestFieldsFragment): React.JSX.Element => {
	const { formatMessage, formatDate } = useIntl();
	const categoryName = category?.data?.attributes?.title;
	const formattedPublishDate = publishedAt ? formatDate(publishedAt) : undefined;
	const formattedStartDate = startDate ? formatDate(startDate) : undefined;
	const formattedEndDate = endDate ? formatDate(endDate) : undefined;
	const hasContent = description || startDate || categoryName || keywords;

	if (!hasContent) return <></>;

	return (
		<BaseModule
			defaultModuleOptions={{
				__typename: 'ComponentInternalDefaultModuleOptions',
				backgroundColor: 'white',
				padding: 'small'
			}}
		>
			<div className={styles.wrapper}>
				<div className={styles.content}>
					<h2>{formatMessage({ id: 'open.woo.detail.body.title' })}</h2>
					{description && <p>{description}</p>}
				</div>

				<div className={styles.list}>
					{startDate && (
						<div>
							<strong>{formatMessage({ id: 'open.woo.detail.body.date' })}: </strong>
							<span>{formattedPublishDate}</span>
						</div>
					)}

					{startDate && (
						<div>
							<strong>{formatMessage({ id: 'open.woo.detail.body.dateRange' })}: </strong>
							<span>
								{formattedEndDate
									? formatMessage(
											{ id: 'open.woo.detail.body.dateRange.value' },
											{ formattedStartDate, formattedEndDate }
									  )
									: formattedStartDate}
							</span>
						</div>
					)}

					{categoryName && (
						<div>
							<strong>{formatMessage({ id: 'open.woo.detail.body.category' })}: </strong>
							<span>{categoryName}</span>
						</div>
					)}

					{caseNumber && (
						<div>
							<strong>{formatMessage({ id: 'open.woo.detail.body.caseNumber' })}: </strong>
							<span>{caseNumber}</span>
						</div>
					)}

					{keywords && (
						<div>
							<strong>{formatMessage({ id: 'open.woo.detail.body.keywords' })}: </strong>
							<span>{keywords}</span>
						</div>
					)}
				</div>
			</div>
		</BaseModule>
	);
};

export default OpenBody;
